<template>
  <div style="
    height: 100%;
">
    <hshead title="用户沟通" bgcolor="#fff"></hshead>
    <div class="product-ul" style="
    height: 100%;
">
      <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
        <div class="product-li" v-for="(item, index) in list" :key="index">
          <!-- <div class="left-img">
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="item.coverUrl" v-if="item.coverUrl"></van-image>
            <van-image fit="cover" width="2.2rem" height="2.2rem" :src="tempImg" v-else></van-image>
          </div> -->
          <div class="center-p">
            <div class="center-top">
              <!-- <div class="img-box">
                <img src="~@/assets/images/product/logo.png" alt />
              </div> -->
              <div class="this-p">
                {{item.consultUserName}}
                <span>（{{item.consultUserMobile}}）</span>
                <span>#{{item.isOnline?'在线':'已离线'}}#</span>
              </div>
            </div>
            <div class="del-pri" style="text-decoration:none;">{{item.consultUnReadCount}}条未读消息</div>
            <div class="del-pri" style="text-decoration:none;">最近一次咨询：{{item.lastMessage}}（{{item.lastCreateTime}}）</div>
            <!-- <div class="user-pri" style="color:#ff0000;" v-if="item.isOnline">用户在线</div>
            <div class="user-pri" style="" v-else>用户已离线</div> -->
          </div>
          <div class="right-btn-box">
            <!-- <router-link @click="handleShowChatInfo(item)" class="right-btn">查看对话</router-link> -->
            <a @click="handleShowChatInfo(item)" class="right-btn">查看对话</a>
          </div>
        </div>
      </van-list>
      <div v-if="finished" class="emptyDataDiv_gray">
        <div v-if="list.length==0">
          <van-icon name="info" />
          <p>暂无对话</p>
        </div>
        <div v-else>没有更多了</div>
      </div>
    </div>
     <van-tabbar v-model="active">
      <van-tabbar-item to="MissionHall">
        <span>任务中心</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_taskCenter.active : icon_taskCenter.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Income" icon="chart-trending-o">
        <span>收益</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_earnings.active : icon_earnings.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Grapher" icon="manager-o">
        <span>摄影师</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_cameraman.active : icon_cameraman.inactive
            "
          />
        </template>
      </van-tabbar-item>

      <van-tabbar-item to="Product" icon="orders-o">
        <span>商品管理</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_product.active : icon_product.inactive
            "
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="Other" icon="apps-o">
        <span>更多</span>
        <template #icon="props">
          <img
            :src="
              props.active ? icon_more.active : icon_more.inactive
            "
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>


    <!-- 查看对话 -->
    <div v-if="dialogVisible">
      <div class="el-dialog__wrapper" style="z-index: 10;">
        <div role="dialog" aria-modal="true" aria-label="金店长（13620000000） #已离线#" class="el-dialog" style="width: 100%;">
          <div class="el-dialog__header">
            <span class="el-dialog__title">
              <div>{{dialogTitle}}</div>
              <div>#{{curChatUserInfo.isOnline ? '当前在线':'已离线'}}#</div>
            </span>
            <button type="button" aria-label="Close" class="el-dialog__headerbtn">
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
            <van-icon name="close" size="0.7rem" @click="dialogVisible=false" />
          </div>
          <div class="el-dialog__body">
            <div :style="{ height: clientHeight + 'px' }">
              <div id="service">
                <div id="serviceContent" class="service-content" style="height:73%;">
                  <div class="service-content-out">
                    <template v-if="chatMsgList!=null">
                      <div v-if="isFinished" class="loadMoreFinish">== 已加载全部消息 ==</div>
                      <div v-else class="loadMore" @click="loadMore()">查看更多</div>
                    </template>
                    <div v-for="(item, index) in chatMsgList" :key="item.id">
                      <template v-if="isShowDate(chatMsgList, index)">
                        <div class="service-time">{{item.createTime}}</div>
                      </template>
                      <template v-if="item.isSelf">
                        <div class="right-content">
                          <div class="this-icon">
                            <img v-if="storeInfo && storeInfo.logoUrl" :src="StaticWebSite + '/' + storeInfo.logoUrl" class="user-avatar" style="height:100%;">
                            <img v-else src="data:image/jpeg;base64,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" class="user-avatar">
                          </div>
                          <div class="right-content-p">{{item.message}}</div>
                          <div class="clear"></div>
                      </div>
                      </template>
                      <template v-else>
                        <div class="left-content">
                          <div class="this-icon">
                            <img :src="curChatUserInfo.headIcon || 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/wAALCAH0AfQBAREA/8QAGgABAQEBAQEBAAAAAAAAAAAAAAQBAgMFB//EACwQAQACAgEDBAEEAgIDAAAAAAABAgMRBCEycRIxQVEiE0JhkRShNFIjM7H/2gAIAQEAAD8A/aQAAAAAAAAAAAAAAAAAAABXTsr4SAAAAAAAAAAAAAAAAAAAACunZXwkAAAAAAAAAAAAAAAAAAAAFdOyvhIAAAAAAAAAAAAAAAAAAAAK6dlfCQAAAAAAAAAAAAAAAAAAAAV07K+EgAAAAAAAAAAAAAAAAAAAArp2V8JAAAAAAAAAAAAAAAAAAAABXTsr4SAAAAAAAAAAAAAAAAAAAACunZXwkAAAAAAAAAAAAAAAAAAAAFdOyvhIAAAAAAAAAbj7ZuD1M9X8N9R6o+27AAAAAAAAAV07K+EgAAAAAAADJnTPVudREvWvGzXjcTGnrXhf9v8A69Y4WGP2z/br/ExfU/2f4uL6/wBs/wAPD9T/AG5twcWvxj/bxtwrx26eN8eTH3f6cxff23bQAAAAAAAV07K+EgAAAAAAAyZ0Vi151SNyoxcLfXJuJV0xVpGo6vTQAAyYifh5X41L++48PG3Ap8Wtt5W4d47YmXE8fPH7P9uZx5Y96s1ePhn5fTesTqWgAAAAArp2V8JAAAAAAAGTL0w8e2WdzusePdfjw0xx0rG/vT0AAAABk1rPvEOf0qf9Y/onFjj9kf0+blvF8sTEaiPpgAAAAAK6dlfCQAAAAAAHMzpTx+N6p9V+q6IisREezQAAAAAT8rN+nTpPXb59YdAAAAAArp2V8JAAAAAABkzpTxuPMz67LojUAAAAAAPHkZ64a9fefZ861py39dvloAAAAACunZXwkAAAAAAZM6h68bDOW/qnpX4fRiIiOjQAAAAAHlnxRkp/Mez5sxOO3pt0mGgAAAAAK6dlfCQAAAAABlYm+SKx7TPV9TFjjHSK/TsAAAAAAEfMw7j11jrtJE7aAAAAACunZXwkAAAAABlp1Cvh4tbtb56wsAAAAAAAZMbjT5eXH+lliv31YAAAAACunZXwkAAAAABkV/UyRT7fUx19OOsfUOwAAAAAABJzce6Tf6hHWejQAAAABXTsr4SAAAAAA9eJT1ZYv9S+iAAAAAAADjLT145r9vl69OS9fqdNAAAAAFdOyvhIAAAAAMtOoWcGusVvKsAAAAAAAB8vPX05pn7lyAAAAAK6dlfCQAAAAAc39o8vp8evpo9QAAAAAAAEHPjV8cw8AAAAABXTsr4SAAAAADm/tHl9esarHhoAAAAAAACLnx1olj2aAAAAArp2V8JAAAAABxf48vsV7Y8NAAAAAAAARc79iWPZoAAAACunZXwkAAAAAHF/jy+xXthoAAAAAAACLnfsSx7NAAAAAV07K+EgAAAAA4v8eX2K9seGgAAAAAAAIud+xLHs0AAAABXTsr4SAAAAADi/x5fYr2x4aAAAAAAAAi537EsezQAAAAFdOyvhIAAAAAyN2nURL0jh5L6n1RD6UdIhoAAAAAAACflYLZoj0zrSO3HyY46zvw4ifuNNAAAABXTsr4SAAAAAzU2tFY95fRwYYx0jp111ewAAAAAAAABraHl4YrH6kJoaAAAAK6dlfCQAAAAHWCN8inl9QAAAAAAAAAHlyI3imHza+8tAAAAFdOyvhIAAAADcM65NPL6oAAAAAAAAAPHkz6cUy+dX3loAAAArp2V8JAAAAAZv03i30+nht6sVZ+4dgAAAAAAAACTm5Pw9Hykj2aAAAAK6dlfCQAAAAGTG4U8PL1ms+0ey0AAAAAAAABlp1Ey+Zlv+rl9XwwAAAAFdOyvhIAAAAAyJml4tH2+lhyRkpFnoAAAAAAAACTl5vTHprPXfVJWNQ0AAAAFdOyvhIAAAAAyfZ6cfLOK+p7fp9GJiY6NAAAAAAAAeebJGOkzvrro+bMzkvN5+WgAAAAK6dlfCQAAAAAZMbU8XkdfRaesrQAAAAAAAc3vFKzafZ83NlnNk9+kT0Z7AAAAACunZXwkAAAAABzMddwt43IiY9Fukx0hUAAAAAAAy1orG5fOz55y21Ha84jUNAAAAAFdOyvhIAAAAAA561ncTrT6PGyevFWZnq9gAAAAAAQ8vLM2mlZ1pPEaaAAAAACunZXwkAAAAAAJ9npxcnoyTEz00+iAAAAAAOMlvRSZ/h8ybfqX9c/LQAAAAAFdOyvhIAAAAAAObR1iX0ePl/Vpt7AAAAAAIeXl9UxSvxPVPEahoAAAAACunZXwkAAAAAAB1gyfpZOva+lWdxEtAAAAAHlnyxjxz16/D53W1ptPy0AAAAAAV07K+EgAAAAAAMtG4U8XP+y0+NrQAAAAGWtFY3M6fMzZZy3/iGAAAAAAArp2V8JAAAAAAAHM7ifVX3hfxs8Xr6Z9491AAAAATOofP5Oeck+iva8YjTQAAAAAAV07K+EgAAAAAAA561mLR8dX0uPknLhi0+8vUAAABDy80+qaR8J4jTQAAAAAAFdOyvhIAAAAAAAMt2ys4U/8AiiFQAAAD5nJ/5NnIAAAAAAArp2V8JAAAAAAABlu2VfC/9cKwAAAHzOR/ybOQAAAAAABXTsr4SAAAAAAADLe0ruHGuPVQAAAA+dyo1mmXmAAAAAAAK6dlfCQAAAAAAAc9bXrEfb6mKnoxxV2AAAAk5uObY4mI67SVnbQAAAAAAFdOyvhIAAAAAAA5mfiOsq+Nx9fnbrM9YifhYAAAAMtWLRqXzc2GcV+nWriJaAAAAAACunZXwkAAAAAABzM7nULOPxfTq14iZ+FfsAAAAA5vSt66tG4fPzYLYp3GvS84nbQAAAAABXTsr4SAAAAAAMmdNpjvln8Y3C7Dxq4uvXf8vcAAAAAGTETGpR5+J1m1NzKXc1n026S6AAAAAAV07K+EgAAAAAzcEeq/SsTPhRh4kzq15nxMLK0rSOkRHh0AAAAAADyyYK5I9oifvSLJxr4p/HdoeXq10npLrYAAAAArp2V8JAAAAAZ6iItadRWVGPh2nraYmFdMNMfbXTsAAAAAAACY28MnFpfcxWN/aTJxr4+u9x/Dy3Me9ZbEw0AAAAV07K+EgAAAEzpzvc6h7U4uW/WdaUU4eOvWYnaitYrGoaAAAAAAAAAPO+GuTuhPk4Ufsjr/ACnvhyY+7WnEWh0AAACunZXwkAAAZMxBWL5J1SNvfHw5t1vuFdMVaRqI29AAAAAAAAAAAGTET7w8cvFpk+deEl+Nkp2xMw8vVqdT0l0AAArp2V8JAAAc7mZ1WJnwoxcSbflaZ8TCymKlPasQ7AAAAAAAAAAAACY37vHJxqXjpERP3pFkwXxT03aPDiLNAAFdOyvhIAAyZ06xYr5p6e0fa7Fx6Y43r8vl7AAAAAAAAAAAAAAyY3GpS5uJE9ccREpJiaTqzdgAK6dlfCQAHMz11CnBxJn8sm4lbFYrERHw0AAAAAAAAAAAAAAHnlw1yxqf9IMuC+Kfb8XETEtAFdOyvhIAMiJvOqxtbg40Ujdus/zCkAAAAAAAAAAAAAAAGWrFo1MRKHPxprM3puf4h4RbbQFdOyvhIAyInJaK1+flfhwVx1jpG3ttuzZtmzZtuzZs2zbdmzZs2zbdm2bbtm27Zs23Zs2zZs23Zs2bZtuzZs2bZtuzbNt2zbds2T1Rcjja/Oka/iE0T8T7ugV07K+EgOdTe3pr7voYMMY6+3V7AAAAAAAAAAAAAAAAACLk8fX508ynrO4aK6dlfCQczPWI+13GweiNz7qAAAAAAAAAAAAAAAAAAZMbjSDk4Jpb11+ZeUTuGq6dlfCQenGrFsk7jb6AAAAAAAAAAAAAAAAAAA5yViaTuN9HzNas1ZTsr4f/2Q=='">
                          </div>
                          <div class="left-content-p">{{item.message}}</div>
                          <div class="clear"></div>
                        </div>
                      </template>
                    </div>

                  </div>
                </div>
                <div class="service-save">
                  <div class="save-textarea">
                    <textarea maxlength="200" name="" id="smsTextarea" @blur="textareaBlur" placeholder="回复用户（200字内）" v-model.trim="smsTextarea"></textarea>
                  </div>
                  <div class="right-btn" @click="sendSms()">发送</div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Toast, Image, Tabbar, TabbarItem, List, Icon, Dialog } from "vant";
import tempImg from "@/assets/images/product/tempBus.jpg";
import { getProductPager, updateProductStatusBatch } from "@/api/m/store";
import { getMsgSummaryPager, fetchChatMsgPager, getUserStatus, updateData } from "@/api/m/userChat";
import { getStoreDetail } from "@/api/m/store";
import { diffTimeSecond, parseTime } from '@/utils';
// 任务中心
import taskCenter_icon from "@/assets/images/center/nav-1.png";
import taskCenter_icon_act from "@/assets/images/center/nav-1-act.png";
//收益
import earnings_icon from "@/assets/images/center/nav-2.png";
import earnings_icon_act from "@/assets/images/center/nav-2-act.png";
//摄影师
import cameraman_icon from "@/assets/images/center/nav-3.png";
import cameraman_icon_act from "@/assets/images/center/nav-3-act.png";
//商品管理
import product_icon from "@/assets/images/center/nav-4.png";
import product_icon_act from "@/assets/images/center/nav-4-act.png";
//更多
import more_icon from "@/assets/images/center/nav-5.png";
import more_icon_act from "@/assets/images/center/nav-5-act.png";

export default {
  name: "userChat",
  data() {
    return {
      StaticWebSite: window.StaticWebSite,
      tempImg: tempImg,
      list: [],
      active: -1,
      loading: false,
      finished: false,
      listQuery: {
        pn: 1,
        ps: 10,
      },
      // 查看对话
      dialogVisible: false,
      dialogTitle: '',
      smsTextarea: '',
      curChatUserInfo: {},
      chatMsgList: null,
      isFinished: false,
      clientHeight: window.document.body.clientHeight,
      //
      storeInfo: null,
        icon_taskCenter: {
        active: taskCenter_icon_act,
        inactive: taskCenter_icon,
      },
      icon_earnings: {
        active: earnings_icon_act,
        inactive: earnings_icon,
      },
      icon_cameraman: {
        active: cameraman_icon_act,
        inactive: cameraman_icon,
      },
      icon_product: {
        active: product_icon_act,
        inactive: product_icon,
      },
      icon_more: {
        active: more_icon_act,
        inactive: more_icon,
      },
    };
  },
  methods: {
    onLoad() {
      const that = this;
      if(window.ReceiveMessageFunc) {
        // 当有新消息过来时，如果刚好是正在对话的用户，就直接显示到对话列表中
        const ReceiveMessageFunc = window.ReceiveMessageFunc;
        window.ReceiveMessageFunc = function(userId, message, userInfo) {
          if(that.curChatUserInfo.userId == userId && that.dialogVisible) {
            const item = {
              createTime: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
              fromUserId: userId,
              id: Math.random(),
              isSelf: false,
              message: message,
              msgStatus: 2,
              toUserId: ''
            }
            that.chatMsgList = [...that.chatMsgList, item];
            that.chatScrollToBottom();
            //window.ReceiveMessageFunc = ReceiveMessageFunc;
          }
          else {
            ReceiveMessageFunc(userId, message, userInfo);
            window.ReceiveMessageFunc = ReceiveMessageFunc;
          }
        }
      }
      window.showChatWindow = function(fromUserId, message, userInfo) {
        console.info('切换会话窗口', JSON.parse(userInfo))
        //切换会话窗口
        that.dialogVisible = false
        const row = {
          fromUserId: fromUserId,
          isOnline: true,
          lastCreateTime: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
          consultUserMobile: JSON.parse(userInfo).Mobile,
          consultUnReadCount: 0,
          consultUserName: JSON.parse(userInfo).UserName,
          consultUserId: fromUserId
        };
        that.handleShowChatInfo(row);
      }
      that.getList();
      // 加载店铺详细信息
      that.getStoreDetail();
    },
    //用户沟通列表
    getList() {
      const that = this;
      getMsgSummaryPager(this.listQuery).then(response => {
        console.info('response', response)
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('getMsgSummaryPager -> data', data)
          this.listQuery.pn = this.listQuery.pn + 1
          //
          if(data.totalRecord == 0){
            this.loading = false;
            this.finished = true;
          }
          else {
            data.list.map(item => {
              this.list.push(item)
            })
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            if (this.list.length >= data.totalRecord) {
              this.finished = true;
            }
          }
          //如果是别的页面进来，如果列表中有对应上的聊天用户，就直接打开对话窗口
          let { fromUserId } = this.$route.query;
          let row = null;
          this.list.map(item => {
            if(item.consultUserId == fromUserId) row = item
          })
          if(row) {
            setTimeout(function(){
              that.handleShowChatInfo(row);
            }, 1000 * 0)
          }
        }
      })
      .catch(response => {
        //this.tips(`${response.msg}`);
        Toast.fail({duration:1000 * 5, message: `${response.msg}`});
      });
    },
    // 查看对话
    handleShowChatInfo(row) {
      console.info('查看对话', row);
      this.dialogVisible = true;
      this.chatMsgList = [];
      this.isFinished = false;
      this.getUserStatus(row.consultUserId)
      this.getMsgList(row.consultUserId)
    },
    // 获取用户状态
    getUserStatus(toUserId) {
      this.listLoading = true;
      this.dialogTitle = '加载中...'
      getUserStatus(toUserId).then(response => {
        this.listLoading = false;
        //console.info("getUserStatus->response", response);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.curChatUserInfo = response.data
          this.dialogTitle = `${this.curChatUserInfo.userName}（${this.curChatUserInfo.mobile}）`
        }
      }).catch(response => {
        this.listLoading = false;
        this.$message({message: response.msg, type: 'error', duration: 1000 * 5})
      });
    },
    // 对话记录是否显示日期
    isShowDate(chatMsgList, index) {
      if(index == 0) return true;
      const prevDateTime = chatMsgList[index - 1].createTime
      const curDateTime = chatMsgList[index].createTime
      const diffSecond = diffTimeSecond(prevDateTime, curDateTime); //两个日期相差的秒数
      //console.info('isShowDate', chatMsgList, index, diffSecond)
      return diffSecond > 300; //相差5分钟就显示
    },
    // 跟某个用户的对话记录
    getMsgList(toUserId, id, ps) {
      this.load(true, "加载中...");
      const query = {
        toUserId,
        id: id || '',
        ps: ps || 10
      }
      fetchChatMsgPager(query).then(response => {
        this.load(false);
        console.info("getMsgList->response", response);
        const { code, msg, data } = response;
        if (code >= 0) {
          this.chatMsgList = [...response.data, ...this.chatMsgList];
          if(!id) this.chatScrollToBottom();
          if(response.data.length < query.ps) this.isFinished = true;
        }
      }).catch(response => {
        this.load(false);
        this.$message({message: response.msg, type: 'error', duration: 1000 * 5})
      });
    },
    // 查看更多（跟某个用户的对话记录）
    loadMore() {
      this.getMsgList(this.curChatUserInfo.userId, this.chatMsgList[0].id);
    },
    // 发送消息
    sendSms() {
      const txt = this.smsTextarea
      const toUserId = this.curChatUserInfo.userId
      if(txt) {
        console.info('发送消息', toUserId, txt)
        if(window.SendMessageFunc) {
          window.SendMessageFunc(toUserId, txt, true);
          const item = {
            createTime: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}'),
            fromUserId: "",
            id: Math.random(),
            isSelf: true,
            message: txt,
            msgStatus: 1,
            toUserId: toUserId
          }
          this.chatMsgList = [...this.chatMsgList, item];
          this.smsTextarea = '';
          this.chatScrollToBottom();
        }
        else {
          console.info('本地无法测试，要更新到测试站点或线上');
        }
      }
    },
    // 对话信息滚动到底部
    chatScrollToBottom() {      
      this.$nextTick(function(){
        var div = document.getElementById('serviceContent');
        //console.info('对话信息滚动到底部', div)
        if(div != null) {
          div.scrollTop = div.scrollHeight + 200;
        }
      })
    },
    textareaBlur() {
      console.info('textareaBlur');
      window.scrollTo(0, document.body.offsetHeight);
    },
    // 加载店铺详细信息
    getStoreDetail() {
      getStoreDetail().then(response=>{
        console.info('加载店铺详细信息->response', response)
        const {code, data:{pStoreManager, pStoreGrapherCollect, pPlatformImages, pStores, storeLevelName}} = response
        if( code >=0 ){
          this.storeInfo = pStores
        }
      }).catch(response => {
        this.$message({message: response.msg, type: 'error', duration: 1000 * 5})
      });
    },
  },
  components: {
    hshead,
    "van-image": Image,
    "van-tabbar": Tabbar,
    "van-tabbar-item": TabbarItem,
    "van-list": List,
    "van-icon": Icon,
    [Dialog.Component.name]: Dialog.Component,
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/common.less";
@import "~@/assets/less/mixin.less";
.product-ul {
  background-color: #eef2f5;
  padding: 0.25rem (7.5-6.94rem)/2;
  padding-bottom: 1rem;
  .product-li {
    width: 6.94rem;
    height: 2.2rem;
    background-color: #ffffff;
    border-radius: 0.1rem;
    display: flex;
    margin-bottom: 0.25rem;
    .left-img {
      width: 2.2rem;
    }
    .center-p {
      width: 100%;
      padding-left: 0.17rem;
      padding-top: 0.4rem;
      .center-top {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.45rem;
        letter-spacing: 0rem;
        color: #333333;
        display: flex;
        .img-box {
          width: 0.32rem;
          height: 0.32rem;
          background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
            linear-gradient(#e2bebf, #e2bebf);
          background-blend-mode: normal, normal;
          border-radius: 50%;
          overflow: hidden;
          margin-top: 0.05rem;
          margin-right: 0.2rem;
          img {
            width: 100%;
          }
        }
        .this-p {
          flex: 1;
          font-family: PingFang-SC-Bold;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.45rem;
          letter-spacing: 0rem;
          color: #333333;
          margin-bottom: 0.2rem;
          span {
            color: #999999;
          }
          font-weight: bold;
        }
      }
      .center-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.28rem;
        font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #ff3087;
        padding-left: 0.3rem;
      }
      .del-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        // font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: line-through;
        padding-left: 0.3rem;
      }
      .user-pri {
        height: 0.29rem;
        font-family: PingFang-SC-Medium;
        font-size: 0.2rem;
        // font-weight: bold;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #999;
        text-decoration: none;
        padding-left: 0rem;
        padding-top: 0.15rem;
      }
    }
    .right-btn-box {
      flex: 1;
      margin-right: 0.3rem;
      .right-btn {
        width: 1.36rem;
        height: 0.4rem;
        background-color: #00b8f5;
        border-radius: 0.2rem;
        border: solid 1px #00b8f5;
        color: #ffffff;
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        line-height: 0.4rem;
        display: block;
        text-align: center;
        margin-top: 0.5rem;
        &.nobg {
          color: #00b8f5;
          background-color: #fff;
        }
      }
    }
  }
}
.el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    .el-dialog {
      margin-bottom: 20px;
      transform: none;
      left: 0;
      position: relative;
      margin: 0 auto;      
      background: #FFFFFF;
      border-radius: 2px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
      box-sizing: border-box;
      .el-dialog__header {
        position: fixed;
        background-color: #fff;
        width: 100%;
        z-index: 1;
        padding: 0.1rem;
        .el-dialog__title {
          line-height: 24px;
          font-size: 18px;
          color: #303133;
        }
        .el-dialog__headerbtn {
          position: absolute;
          top: 20px;
          right: 20px;
          padding: 0;
          background: transparent;
          border: none;
          outline: none;
          cursor: pointer;
          font-size: 16px;
        }
        .van-icon-close {
          position: fixed;
          top: 0.2rem;
          right: 0.2rem;
          color: #ff0000;
        }
      }
      .el-dialog__body {
        // padding: 30px 20px;
        color: #606266;
        font-size: 14px;
        #service{width:100%;height:100%;overflow:hidden;font-family:"微软雅黑"}
        #service .service-head{width:100%;height:1rem;line-height:1rem;color:#333;background:#eee;position:fixed;left:0;top:0;font-size:.3rem;text-align:center;border-bottom:.02rem solid #ddd}
        #service .service-head .back-img{position:absolute;left:0;top:0;width:.8rem;height:1rem;line-height:1rem}
        #service .service-head .back-img img{height:.5rem;vertical-align:top;margin-top:.25rem}
        #service .service-head .close-btn{color:#ccc;height:1rem;line-height:1rem;right:.2rem;width:1rem;position:absolute;top:0;text-align:right;font-size:.6rem;cursor:pointer}
        #service .service-content{background:#ececec;padding-bottom:60px;margin-top:55px;overflow:auto;overflow-x:hidden}
        #service .service-content .service-content-out{padding-bottom: .5rem;}
        #service .service-content .service-content-out>div{display: inline-block;}
        #service .service-content .service-content-out .loadMore{width: 100%;text-align: center;padding-top: 0.5rem;text-decoration: underline;color: blue;}
        #service .service-content .loadMoreFinish {width: 100%;font-size: .24rem;text-align: center;margin-top: .3rem;color: #ccc;padding: 0 0 20px;}
        #service .service-content .service-time{width:100%;font-size:.24rem;text-align:center;color:#ccc;margin-top:.3rem}
        #service .service-content .left-content,#service .service-content .right-content{width:7.2rem;padding:0 .15rem;margin-top:.2rem}
        #service .service-content .left-content .this-icon,#service .service-content .right-content .this-icon{width:.8rem;height:.8rem;margin-left:.2rem;border-radius:50%;overflow:hidden;float:left;background:#ccc}
        #service .service-content .left-content .this-icon img,#service .service-content .right-content .this-icon img{width:100%;vertical-align:top}
        #service .service-content .left-content .left-content-p,#service .service-content .left-content .right-content-p,#service .service-content .right-content .left-content-p,#service .service-content .right-content .right-content-p{width:auto;max-width:4.8rem;margin-left:.3rem;padding:.2rem;border-radius:.1rem;background:#94e96b;font-size:.28rem;margin-top:.1rem;line-height:1.4;position:relative;word-wrap:break-word}
        #service .service-content .left-content .left-content-p,#service .service-content .right-content .left-content-p{float:left;margin-left:.3rem;background:#fff}
        #service .service-content .left-content .left-content-p::before,#service .service-content .right-content .left-content-p::before{content:'';position:absolute;width:0;height:0;left:-.28rem;border-width:.15rem;border-style:solid;border-color:transparent #fff transparent transparent}
        #service .service-content .left-content .right-content-p,#service .service-content .right-content .right-content-p{float:right;margin-right:.3rem}
        #service .service-content .left-content .right-content-p::after,#service .service-content .right-content .right-content-p::after{content:'';position:absolute;width:0;height:0;right:-.28rem;top:.2rem;border-width:.15rem;border-style:solid;border-color:transparent transparent transparent #94e96b}
        #service .service-content .right-content .this-icon{float:right;margin-right:.2rem}
        #service .service-save{width:100%;bottom:0;background:#ededed;left:0;padding:.2rem;border-top:.02rem solid #ddd;position:fixed}
        #service .service-save .save-textarea{float:left;border:none;width:5.1rem;background:#fff;border-radius:.1rem;overflow:hidden}
        #service .service-save .save-textarea textarea{resize:none;font-size:.28rem;line-height:1.4;border:none;outline:0;padding:.2rem;width:4.7rem;font-family:"微软雅黑"}
        #service .service-save .right-btn{float:left;width:1.8rem;height:.8rem;line-height:.8rem;background:#01ad59;color:#fff;text-align:center;font-size:.28rem;margin-left:.2rem;border-radius:.1rem;margin-top:.15rem}
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/store/userChat.vue